export interface Timestamped {
  readonly createdAt: number
  readonly updatedAt: number
}

export function createTimestamps(): Timestamped {
  const now = Date.now()
  return {
    createdAt: now,
    updatedAt: now,
  }
}

export function updateTimestamps(existing?: Timestamped | null): Timestamped {
  const now = Date.now()
  return {
    createdAt: existing?.createdAt ?? now,
    updatedAt: now,
  }
}
